import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, footerMenusActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, footerMenusActions);

export default slice.reducer;
